// extracted by mini-css-extract-plugin
export var gif = "_jc-0";